import {Injectable} from '@angular/core';
import { BehaviorSubject, filter, lastValueFrom, map, take } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserStorageService {

  private storageKey = 'door-vision-user';
  private userId?: string
  private isUserIdValidated = new BehaviorSubject(false);

  public storeUserId(userId: string): string {
    localStorage.setItem(this.storageKey, userId);
    this.userId = userId;
    return this.userId
  }

  public setUserIdValidated(value: boolean): void {
    this.isUserIdValidated.next(value);
  }

  public waitForUserIdIsValidated(): Promise<string | undefined> {
    return lastValueFrom(this.isUserIdValidated.pipe(filter(v => v), map(() => this.userId), take(1)));
  }

  public getUserId(): string | undefined {
    if (!this.userId) {
      const userIdFromLocalStorage = localStorage.getItem(this.storageKey)
      if (userIdFromLocalStorage !== null) {
        this.userId = userIdFromLocalStorage
      }
    }
    return this.userId
  }
}
